"use client"

import { Snowflake } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SnowflakeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SnowflakeIcon = component(Icon)({ as: Snowflake })
